import React, { useState, useEffect, useRef } from 'react';
import { Spinner } from "views/Hoc/Spinner";
import CountryFlag from 'views/Hoc/countryFlag/countryFlag';
import ReactCountryFlag from "react-country-flag"
import axios from 'axios';
import { useTheme, useMediaQuery } from "@mui/material";
import { ToastsContainer, ToastsStore } from 'react-toasts';
import GuestNavBar from 'views/pages/GuestPage/GuestNavbar/GuestNavbar';
import { Card, CardBody, CardHeader, Row, Col, CardImg, Container, Button } from "reactstrap";
import { grey } from '@material-ui/core/colors';
import { Background } from 'devextreme-react/range-selector';
const PublicConnectedMeetingsDetailView = (props) => {
  let [loading, setLoading] = useState(true);
  let [meetings, setConnectedMeetings] = useState([]);
  let [eventName, setEventName] = useState('Channel Summit');
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("xl"));
  useEffect(() => {
    //console.log('props.match: ', (props.location.pathname).split('/'))
    let eventId = (props.location.pathname).split('/')[2];
    //console.log('props.match: ', eventId )
    getConnectedMeetings(eventId)
  }, []);

const getConnectedMeetings = async (eventId) => {
    try {
      setLoading(true)
      const res = await axios.get(`/publicChannel/getConnectedMeetingsForSlider/`+eventId);
      if (res) {
       
        setConnectedMeetings(res.data[0].uniqueMeeting);
        setEventName(res.data[0].name[0].name)
        setLoading(false)
      }
    } catch (error) {
      console.log(error);
    }
  };

  const toggelDesc = async (descId) => {
    //console.log('record : ', descId)
    let divBlog = document.getElementById(descId);
 

    //  console.log('stylee ==== ', divBlog)
    if(divBlog) {
      
      if (divBlog.className == "hideDesc") {
        divBlog.className = "";
        divBlog.classList.toggle('showDesc'); 
         // Show the div
      } else {
        divBlog.className = "";
        divBlog.classList.toggle('hideDesc'); // Hide the div
      }
    }
  }

  return (
    <div id='channel-detail' className="main-content" style={{backgroundColor:'white'}}>
      <GuestNavBar />
      <ToastsContainer position="top_right" autoClose={5000} store={ToastsStore} />
       <Card style={{ textAlign:'center' }}>
            <div
            style={{
              fontSize: "1.2rem",
              textAlign: "center",
              color: "rgb(50, 50, 93)", 
              fontWeight: "600",
              fontFamily: "inherit",
              paddingBottom:"1rem"
            }}
          >
            Success Stories
          </div>
             <div style={{ fontSize: '1.2rem', textAlign: 'center', color: 'rgb(50, 50, 93)', paddingBottom: '2rem', fontWeight:"600", fontFamily: 'Open Sans, sans-serif'}}>
              {eventName}
          </div>
          <div style={{display: 'flex',  justifyContent: 'center'}}>
            <div className='topTextSS'>
            Below are some recent distribution deals signed through our events. They have been reported by our participants on a voluntary basis. Many more have probably happened below our radar
          </div></div>

      </Card>

      
      <Container className="grid-container">
        {loading ? <Spinner /> :
          <><Row>{meetings &&   meetings.map(x => ( 
          <>
              <Col lg="4" sm="12" md="6" style={{ marginTop : "17px", paddingRight: "7px"}}>

                  <div  style={{ width:"100%", display:'block', border: '1px solid rgb(230 220 220)', padding:"10px 15px 15px 15px", borderRadius:"8px"}}>                      
                        <div style={{width:'35%', verticalAlign:'top', display:'inline-block'}}>
                            <a href="" onClick={e => { 
                                e.preventDefault();  
                                let win = window.open(`/channelDetailView/${x.customUrl}`);
                                win.focus();
                            }}>
                            <img
                            alt="..."
                            style={{maxWidth:'80%'}}
                            // classNa      me="img-fluid shadow-lg--hover"
                            src={x.logo ? process.env.REACT_APP_CDN_URL + x.logo : process.env.REACT_APP_DEFALTIMAGE+"document/company/logo/zF71l5KG_1548153498529_1548153484685.jpg"}
                            /></a>
                        </div>
                        <div style={{width:'65%', display:'inline-block'}}>
                            <div>
                              <div>
                                <span className='channelTySS' 
                                //style={{ padding: '4px 9px 4px 9px', color: 'rgb(61 112 219)',backgroundColor : "#e8e8eb",borderRadius : '9px', fontSize:"15px", fontWeight: 'lighter'}}
                                >{x.channelType}</span>

                                <span style={{float: 'right'}}>
                                  <img
                                  alt="..."
                                  className='plusIconSS'
                                  //style={{maxWidth:'25%', float:'right'}}
                                  src={"/images/plus.png"} onClick={() => toggelDesc('desc_'+x.channelId+'_'+x.id)}
                                  />
                                </span>
                              </div>                   

                              <div className="comName_conn"> {x.companyName} </div>

                              <div style={{width:"2em !important" , height:"1.5em", width:'2em',  paddingTop: '10px', display:'inline-block'}} >
                                  <div>
                                    <ReactCountryFlag
                                        countryCode={x.isoCode}
                                        svg
                                      //className="countryFlagSS"
                                      style={{ width:'1.5em !important', height:'1.5em !important' , display: 'inline-block', verticalAlign : 'middle'}}
                                        title={x.isoCode}
                                    />
                                </div>
                              </div>
                            </div>                            
                        </div>
                        
                        <div className="hideDesc" id={ 'desc_'+x.channelId+'_'+x.id}>{x.detailDesc}</div>

                        <div>  
                          <img
                            alt="..."
                            style={{maxWidth:'12%'}}
                            src={"/images/handshake_connected.png"}
                              />
                        </div>


                         <div style={{width:'35%', verticalAlign:'top', display:'inline-block'}}>
                            <a href="" onClick={e => { 
                                e.preventDefault();  
                                let win = window.open(`/channelDetailView/${x.partnercustomUrl}`);
                                win.focus();
                            }}>
                            <img
                            alt="..."
                            style={{maxWidth:'80%'}}
                            // classNa      me="img-fluid shadow-lg--hover"
                            src={x.partnerLogo ? process.env.REACT_APP_CDN_URL + x.partnerLogo : process.env.REACT_APP_DEFALTIMAGE+"document/company/logo/zF71l5KG_1548153498529_1548153484685.jpg"}
                            /></a>
                        </div>
                        <div style={{width:'65%', display:'inline-block'}}>
                            <div>
                              <div>
                               
                                <span className='channelTySS'>{x.partnerchannelType}</span>

                                <span style={{float: 'right'}}>
                                  <img
                                  alt="..."
                                 // style={{maxWidth:'25%', float:'right'}}
                                 className='plusIconSS'
                                  src={"/images/plus.png"} onClick={() => toggelDesc('desc_'+x.partnerChannelId+'_'+x.id)}
                                  />
                                </span>
                              </div>                   

                              <div className="comName_conn"> {x.partnerCompany} </div>
                              <div style={{width:"2em !important" , paddingTop: '10px', height:"1.5em", width:'2em', display:'inline-block'}} >
                              <div>
                                    <ReactCountryFlag
                                        countryCode={x.partnerisoCode}
                                        svg
                                        //className="countryFlagSS"
                                        style={{ width:'1.5em !important', height:'1.5em !important' , display: 'inline-block', verticalAlign : 'middle'}}
                                        title={x.partnerisoCode}
                                    />
                                </div>
                              </div>
                            </div>

                            
                        </div>
                        
                        <div className="hideDesc" id={ 'desc_'+x.partnerChannelId+'_'+x.id} >{x.partnerDetailDesc}</div>
                  </div>                
                  

              </Col>
          </> ))
        } </Row>
        </>}
   
      </Container>
    </div>

  );
}
export default PublicConnectedMeetingsDetailView;